jQuery(document).ready(function ($) {
    let tableOfContents = $('.single-post__table-of-contents');

    if (tableOfContents.length === 0) {
        return;
    }

    let toggleLabel = tableOfContents.data('toggle-label') || '';
    let groupCount = 0;

    function transformText(text) {
        let withoutSpecialChars = text.replace(/[^\w\s]/gi, '');
        let lowercaseText = withoutSpecialChars.toLowerCase().trim();
        let withHyphens = lowercaseText.replace(/\s+/g, '-');
        return withHyphens || 'section';
    }

    function getHeadingId(heading, text) {
        let base = transformText(text);
        let id = base;
        let count = 2;
        let element;

        // Headings can share a title (e.g. "Stap 1" in multiple step blocks), keep every anchor unique.
        while ((element = document.getElementById(id)) && element !== heading[0]) {
            id = base + '-' + count++;
        }

        heading.attr('id', id);
        return id;
    }

    function getHeadingText(heading) {
        // Collapse/step blocks wrap the title in a button next to a counter and toggle icon.
        let title = heading.find('.main-title__text');
        return (title.length ? title : heading).text().replace(/\s+/g, ' ').trim();
    }

    function createItem(heading, text) {
        // Editors number main headings manually ("1. Title"), show that number in its own column.
        let match = text.match(/^(\d+[.)])\s+(.+)$/);
        let link = $('<a>', {'href': '#' + getHeadingId(heading, text), 'class': 'toc__link'});

        if (match) {
            link.append($('<span>', {'class': 'toc__number', 'text': match[1]}));
        }

        link.append($('<span>', {'class': 'toc__title', 'text': match ? match[2] : text}));

        return $('<li class="toc__item"></li>').append($('<div class="toc__row"></div>').append(link));
    }

    // Items with sub items get a toggle in front of them, all groups start collapsed.
    function createSubList(item) {
        let subListId = 'toc-sublist-' + ++groupCount;
        let subList = $('<ul>', {'class': 'toc__sublist', 'id': subListId}).hide().appendTo(item);
        let toggle = $('<button>', {
            'type': 'button',
            'class': 'toc__toggle',
            'aria-expanded': 'false',
            'aria-controls': subListId,
            'aria-label': (toggleLabel + ' ' + item.find('.toc__title').text()).trim()
        });

        item.children('.toc__row').prepend(toggle);
        return subList;
    }

    function createSubItem(heading, text) {
        let link = $('<a>', {'href': '#' + getHeadingId(heading, text), 'class': 'toc__sublink', 'text': text});
        return $('<li class="toc__subitem"></li>').append(link);
    }

    let headings = $('.page-content').find('h2:not(.block--cta h2, .block--author h2, .single-post__table-of-contents h2), h3:not(.block--cta h3, .blocks__item h3, .block--author h3)');
    let list = $('<ol class="toc"></ol>');
    let currentItem = null;
    let currentSubList = null;

    headings.each(function () {
        let heading = $(this);
        let text = getHeadingText(heading);

        if (!text) {
            return;
        }

        // H3's are grouped under the preceding H2, an H3 without a preceding H2 becomes a main item.
        if (heading.is('h3') && currentItem) {
            currentSubList = currentSubList || createSubList(currentItem);
            currentSubList.append(createSubItem(heading, text));
            return;
        }

        currentItem = createItem(heading, text).appendTo(list);
        currentSubList = null;
    });

    if (list.children().length === 0) {
        tableOfContents.remove();
        return;
    }

    // When any item has a toggle, all items keep the toggle space so the text lines up.
    list.toggleClass('toc--with-toggles', groupCount > 0);
    tableOfContents.append(list);

    list.on('click', '.toc__toggle', function () {
        let toggle = $(this);
        let item = toggle.closest('.toc__item');
        let isOpen = toggle.attr('aria-expanded') === 'true';

        toggle.attr('aria-expanded', isOpen ? 'false' : 'true');
        item.toggleClass('toc__item--open', !isOpen);
        item.children('.toc__sublist').stop(true, true)[isOpen ? 'slideUp' : 'slideDown'](200);
    });
});
